module.exports = __webpack_public_path__ + "static/media/dashboard.1a42c03f.png";